/**
 * Genemo アプリ一覧（family-design v1）— 家族の正本・バイト同一で配布。
 * AppSwitcher / ランチャーはこの一覧だけを使う（アプリごとに独自の一覧を持たない）。
 * ロゴ画像は family-design/brand/ にある。ファイル名は `${logo}.svg|png`、マークは `${logo}-mark.png`。
 */

export type GenemoAppKey = 'home' | 'short' | 'image' | 'page' | 'gold' | 'post' | 'prompt'

export interface GenemoApp {
  key: GenemoAppKey
  /** 正式名（例: Genemo Short） */
  name: string
  /** 短い名前（ナビ用） */
  label: string
  /** 何ができるか（10字前後） */
  desc: string
  url: string
  /** brand/ 配下のファイル名の基幹（genemo-short → genemo-short.svg / genemo-short-mark.png） */
  logo: string
}

export const GENEMO_APPS: readonly GenemoApp[] = [
  { key: 'home', name: 'Genemo Home', label: 'Home', desc: '残高・利用状況のまとめ', url: 'https://home.genemo.jp', logo: 'genemo' },
  { key: 'short', name: 'Genemo Short', label: 'Short', desc: 'ショート動画の自動生成', url: 'https://short.genemo.jp', logo: 'genemo-short' },
  { key: 'image', name: 'Genemo Image', label: 'Image', desc: 'EC商品画像の生成', url: 'https://image.genemo.jp', logo: 'genemo-image' },
  { key: 'page', name: 'Genemo Page', label: 'Page', desc: 'EC商品ページの生成', url: 'https://page.genemo.jp', logo: 'genemo-page' },
  { key: 'gold', name: 'Genemo Gold', label: 'Gold', desc: '楽天GOLDページ生成', url: 'https://gold.genemo.jp', logo: 'genemo-gold' },
  { key: 'post', name: 'Genemo Post', label: 'Post', desc: 'SNS投稿の自動生成', url: 'https://post.genemo.jp', logo: 'genemo-post' },
  { key: 'prompt', name: 'Genemo Prompt', label: 'Prompt', desc: 'プロンプトの作例集', url: 'https://prompt.genemo.jp', logo: 'genemo-prompt' },
]

/**
 * 画面の一番下（gm-footer）に全アプリ共通で出す、運営者と規約のリンク。正本は Short。
 * 左下のアカウントメニューには出さない（2026-10-13 オーナーの判断）。
 */
export const GENEMO_OPERATOR = '株式会社ラクダ'
export const GENEMO_LEGAL_LINKS: ReadonlyArray<{ label: string; url: string }> = [
  { label: '利用規約', url: 'https://short.genemo.jp/terms' },
  { label: 'プライバシーポリシー', url: 'https://short.genemo.jp/privacy' },
  { label: '特定商取引法に基づく表記', url: 'https://short.genemo.jp/legal/specified-commercial' },
]

/** credit_transactions.source_app → アプリキー（利用内訳の表示用） */
export const SOURCE_APP_TO_KEY: Readonly<Record<string, GenemoAppKey>> = {
  'genemo-short': 'short',
  'genemo-image': 'image',
  'genemo-page': 'page',
  'genemo-gold': 'gold',
  'genemo-post': 'post',
}

export const getApp = (key: GenemoAppKey): GenemoApp => GENEMO_APPS.find(a => a.key === key)!
